export default __webpack_public_path__ + "static/media/empty-ld-team-members.21c8a0c1.svg";